export default __webpack_public_path__ + "static/media/green-lightning.6a8442ab.svg";